<template>
  <div class="box">
    <div class="head" v-if="isHead">
      <div class="h_content">
        <img class="h_left" src="../../assets/img/i1.svg" />
        <div class="h_center">
          <el-menu :default-active="tabIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="0">对话</el-menu-item>
            <el-menu-item index="1">助手</el-menu-item>
            <el-menu-item index="2">智能体</el-menu-item>
            <el-submenu index="3">
              <template slot="title">班级课堂</template>
              <el-menu-item index="3-1">班级管理</el-menu-item>
              <el-menu-item index="3-2">课堂智能体管理</el-menu-item>
              <el-menu-item index="3-3">课堂管理</el-menu-item>
              <el-menu-item index="3-4">体验课堂</el-menu-item>
              <el-menu-item index="3-5">题库管理</el-menu-item>
              <el-menu-item index="3-6">学生端登录入口</el-menu-item>
              <el-menu-item index="3-7">学生档案</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">教研活动</template>
              <el-menu-item index="4-1">教研智能体</el-menu-item>
              <!-- <el-menu-item index="4-2">教研智能体评价维度</el-menu-item> -->
              <el-menu-item index="4-3">创建教研组</el-menu-item>
              <el-menu-item index="4-2">教研活动</el-menu-item>
              <el-menu-item index="4-4">教研端登录入口</el-menu-item>
            </el-submenu>
            <el-menu-item index="5">知识库</el-menu-item>
            <el-submenu index="6" v-if="userInfo.ifSchool">
              <template slot="title">学校管理</template>
              <el-menu-item index="6-1">班级管理</el-menu-item>
              <el-menu-item index="6-2">课堂管理</el-menu-item>
              <el-menu-item index="6-3">课堂智能体管理</el-menu-item>
              <el-menu-item index="6-4">账号管理</el-menu-item>
            </el-submenu>
          </el-menu>
          <!-- <div class="hc_tab" :class="index == tabIndex ? 'hct' : ''" v-for="(item, index) in tab" :key="index"
            @click="openPage(index)">
            {{ item }}
            <div class="hct_line" v-if="index == tabIndex"></div>
          </div> -->
        </div>
        <div class="h_right">
          <div class="hr_btn1" @click="$router.replace('/login')" v-if="!token">登录</div>
          <div class="hr_btn2" v-if="!token">立即注册</div>
          <div class="hr_user" v-if="token">
            <div class="hru" @click="isHover = !isHover">
              <img class="hru_left" :src="webImg + userInfo.avatar" />
              <div class="hru_center">
                <div>你好, {{ userInfo.nickName }}</div>
                <div>{{ userInfo.phone }}</div>
              </div>
              <img class="hru_right"
                :src="!isHover ? require('../../assets/img/i69.png') : require('../../assets/img/i70.png')" />
            </div>
            <div class="hru_menu" v-if="isHover">
              <div class="rum_item" @click="isHover = false, $router.push('/my')">
                <div class="umi_left">
                  <img src="../../assets/img/i71.png" />
                  <div>个人信息</div>
                </div>
                <img class="umi_right" src="../../assets/img/i73.png" />
              </div>
              <div class="rum_item" @click="btn_out">
                <div class="umi_left">
                  <img src="../../assets/img/i72.png" />
                  <div>退出登录</div>
                </div>
                <img class="umi_right" src="../../assets/img/i73.png" />
              </div>
            </div>
          </div>
          <!-- <div class="hr_btn2" v-if="token" @click="btn_out">退出登录</div> -->
        </div>
      </div>
    </div>
    <!-- <div class="right">
      <div class="r_item" @click="btn_open(1)" @mouseover="mouseover($event, 1)" @mouseout="mouseout">
        <div v-show="index == 1">课堂转录</div>
        <img src="../../assets/img/i42.png" />
      </div>
      <div class="r_item" @click="btn_open(2)" @mouseover="mouseover($event, 2)" @mouseout="mouseout">
        <div v-show="index == 2">讲座会议转录</div>
        <img src="../../assets/img/i43.png" />
      </div>
    </div> -->
    <transition name="fade" mode="out-in">
      <router-view :class="isHead ? 'rv' : ''" />
    </transition>
  </div>
</template>

<script>
// import 'echarts-gl'
export default {
  data() {
    return {
      tab: ['对话', '助手', '智能体', '课堂智能体', '班级管理', '课堂', '教研', '资源'],
      tabIndex: '0',
      token: '',
      isHead: true,
      index: null,
      isPro: 0, //是否是测试服
      isHover: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    }
  },
  watch: {
    // $route: {
    //   handler(val, oldval) {
    //     console.log(val, 'val'); //新路由信息
    //     console.log(oldval, 'oldval'); //老路由信息
    //     this.setTabIndexByRoute(val.path)
    //   },
    //   immediate: true, // 立即执行一次
    //   // 深度观察监听
    //   deep: true
    // },
    dataFromStore(newData, oldData) {
      // 当store中的数据更新时，这里会被触发
      console.log('Store data updated:', newData);
      this.userInfo = JSON.parse(newData)
    }
  },
  created() {
    this.tabIndex = sessionStorage.getItem('selectedRouteIndex') || '0'
  },
  mounted() {
    // this.isProduction()
    this.token = localStorage.getItem('token')
  },
  methods: {
    setTabIndexByRoute(path) {
      // 根据路由路径设置 tabIndex
      if (path.startsWith('/dialogue')) {
        this.tabIndex = '0'
      } else if (path.startsWith('/assistant')) {
        this.tabIndex = '1'
      } else if (path.startsWith('/intelligentBody')) {
        this.tabIndex = '2'
      } else if (path.startsWith('/classList')) {
        this.tabIndex = '3-1'
      } else if (path.startsWith('/classroomIntelligentBody')) {
        // 这里区分 type 参数
        const type = this.$route.query.type
        if (type == '1') {
          this.tabIndex = '3-2'
        } else if (type == '2') {
          this.tabIndex = '4-1'
        }
      } else if (path.startsWith('/classRoom')) {
        this.tabIndex = '3-3'
      } else if (path.startsWith('/experienceClassRoom')) {
        this.tabIndex = '3-4'
      } else if (path.startsWith('/questionBankManage')) {
        this.tabIndex = '3-5'
      } else if (path.startsWith('/classManage')) {
        this.tabIndex = '6-1'
      } else if (path.startsWith('/classRoomManage')) {
        this.tabIndex = '6-2'
      } else if (path.startsWith('/intelligentBodyManage')) {
        this.tabIndex = '6-3'
      } else if (path.startsWith('/accountManage')) {
        this.tabIndex = '6-4'
      } else if (path.startsWith('/trClassroomDetail')) {
        this.tabIndex = '4-2'
      } else if (path.startsWith('/trClassList')) {
        this.tabIndex = '4-3'
      } else if (path.startsWith('/resource')) {
        this.tabIndex = '5'
      } else {
        // 默认值
        this.tabIndex = '0'
      }
      sessionStorage.setItem('selectedRouteIndex', this.tabIndex)
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.tabIndex = key
      sessionStorage.setItem('selectedRouteIndex', this.tabIndex)
      if (key == 0) {
        this.$router.replace('/dialogue')
      } else if (key == 1) {
        this.$router.replace('/assistant')
      } else if (key == 2) {
        this.$router.replace('/intelligentBody')
      } else if (key == '3-1') {
        this.$router.replace('/classList')
      } else if (key == '3-2') {
        this.$router.replace('/classroomIntelligentBody?type=1')
      } else if (key == '3-3') {
        // this.$router.replace('/dimension?courseType=1')
        this.$router.replace('/classRoom')
      } else if (key == '3-4') {
        this.$router.replace('/experienceClassRoom')
      } else if (key == '3-5') {
        // this.$message.warning('功能开发中...')
        this.$router.replace('/questionBankManage')
      } else if (key == '3-6') {
        // localStorage.removeItem('token')
        // this.$router.replace('/login?activeName=student')
        // 获取当前页面的完整 URL
        const fullUrl = window.location.href;
        // 使用 URL 对象解析 URL
        const urll = new URL(fullUrl);
        // 获取域名部分
        var url = `${urll.protocol}//${urll.host}`;
        window.open(`${url}/#/logins?activeName=student`, '_blank')
      } else if (key == '3-7') {
        this.$router.replace('/archivesClassList')
      } else if (key == '4-1') {
        this.$router.replace('/classroomIntelligentBody?type=2')
      } else if (key == '4-2') {
        // this.$router.replace('/dimension?courseType=2')
        this.$router.replace('/trClassroomDetail')
      } else if (key == '4-3') {
        this.$router.replace('/trClassList')
      } else if (key == '4-4') {
        // localStorage.removeItem('token')
        // this.$router.replace('/login?activeName=teachingResearch')
        // 获取当前页面的完整 URL
        const fullUrl = window.location.href;
        // 使用 URL 对象解析 URL
        const urll = new URL(fullUrl);
        // 获取域名部分
        var url = `${urll.protocol}//${urll.host}`;
        window.open(`${url}/#/logins?activeName=teachingResearch`, '_blank')
      } else if (key == 5) {
        this.$router.replace('/resource')
      } else if (key == '6-1') {
        this.$router.replace('/classManage')
      } else if (key == '6-2') {
        this.$router.replace('/classRoomManage')
      } else if (key == '6-3') {
        this.$router.replace('/intelligentBodyManage')
      } else if (key == '6-4') {
        this.$router.replace('/accountManage')
      }
    },
    mouseover(e) {
      this.isHover = true
    },
    mouseout(e) {
      this.isHover = false
    },
    isProduction() {
      if (process.env.NODE_ENV === 'production') { //development   production
        // 获取当前页面的完整 URL
        const fullUrl = window.location.href;
        // 使用 URL 对象解析 URL
        const urll = new URL(fullUrl);
        // 获取域名部分
        var url = `${urll.protocol}//${urll.host}`;
        if (urll.host.includes('test')) {
          // 如果是部署在测试服下
          this.isPro = 1
        } else {
          this.isPro = 0
        }
      } else {

      }
    },
    btn_open(type) {
      if (process.env.NODE_ENV === 'development') { //development   production
        //开发环境
        window.open(`http://localhost:8081/#/simultaneousInterpretation?type=${type}`, '_blank')
      } else {
        // 获取当前页面的完整 URL
        const fullUrl = window.location.href;
        // 使用 URL 对象解析 URL
        const urll = new URL(fullUrl);
        // 获取域名部分
        var url = `${urll.protocol}//${urll.host}`;
        if (urll.host.includes('test')) {
          // 如果是部署在测试服下
          url = `${urll.protocol}//${urll.host}/pc`;
        }
        window.open(`${url}/#/simultaneousInterpretation?type=${type}`, '_blank')
      }
    },
    // mouseover(e, index) {
    //   this.index = index
    // },
    // mouseout(e, index) {
    //   this.index = null
    // },
    // 退出登录
    btn_out() {
      this.isHover = false
      localStorage.removeItem('token')
      this.$router.replace('/login')
    },
    openPage(index) {
      this.tabIndex = index
      this.isHover = false
      const routes = {
        0: '/dialogue',
        1: '/assistant',
        2: '/intelligentBody',
        3: '/classroomIntelligentBody',
        4: '/classList',
        5: '/classRoom',
        6: '/trClassroomDetail',
        7: '/resource'
      }
      if (routes[index]) {
        this.$router.replace(routes[this.tabIndex])
        sessionStorage.setItem('selectedRouteIndex', this.tabIndex)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-submenu__title i {
    color: #000000;
  }

  .el-menu.el-menu--horizontal {
    border: 0 !important;
  }

  .el-menu--horizontal>.el-menu-item {
    color: #000000;
    font-size: 16px !important;
    font-weight: 400 !important;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    font-weight: bold !important;
    color: #409EFF !important;
  }

  .el-menu--horizontal>.el-submenu .el-submenu__title {
    color: #000000;
    font-size: 16px !important;
    font-weight: 400 !important;
  }

  .el-menu--horizontal .el-menu .el-menu-item.is-active {
    color: #409EFF !important;
  }

  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    color: #409EFF !important;
    font-weight: bold !important;
  }
}

/* 定义过渡效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.1.8+ */
  {
  opacity: 0;
}

.box {
  width: 100%;
  height: 100vh;
  background: #F3F5FA;
  display: flex;
  flex-direction: column;
  align-items: center;


  .rv {
    // width: 100%;
    height: calc(100vh - 70px);
  }

  .right {
    position: absolute;
    right: 20px;
    bottom: 150px;
    z-index: 999;

    .r_item {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      position: relative;

      img {
        width: 70px;
        height: 70px;
      }

      div {
        width: 100px;
        text-align: center;
        position: absolute;
        right: 70px;
        background: #000000;
        border-radius: 8px 8px 8px 8px;
        padding: 10px;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }

  .head {
    width: 100%;
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.05);

    .h_content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .h_left {
        width: 173px;
        height: 37px;
      }

      .h_center {
        flex: 1;
        height: 100%;
        // margin: 0 50px;
        margin-left: 70px;
        display: flex;
        align-items: center;

        .hct {
          font-weight: bold !important;
          color: #2992FF !important;

          &:hover {
            // margin-top: -10px;
          }
        }

        .hc_tab {
          // flex: 1;
          margin: 0 18px;
          height: 100%;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &:hover {
            color: rgba(0, 0, 0, 0.5);
          }

          .hct_line {
            position: absolute;
            bottom: 15px;
            width: 21px;
            height: 3px;
            background: #468FFF;
            border-radius: 2px;
          }
        }
      }

      .h_right {
        display: flex;
        align-items: center;

        .hr_btn1 {
          font-weight: 400;
          font-size: 16px;
          color: #2992FF;
          margin-right: 44px;
          cursor: pointer;

          &:hover {
            color: rgba(0, 0, 0, 0.5);
          }
        }

        .hr_btn2 {
          width: 92px;
          height: 36px;
          background: #2992FF;
          border-radius: 8px 8px 8px 8px;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          line-height: 36px;
          cursor: pointer;

          &:hover {
            background: rgba(85, 139, 220, 0.5) !important;
          }
        }

        .hr_user {
          position: relative;

          .hru {
            display: flex;
            align-items: center;
            cursor: pointer;

            .hru_left {
              width: 38px;
              height: 38px;
              background: #D8D8D8;
              border-radius: 8px;
            }

            .hru_center {
              margin: 0 12px;
              user-select: none;

              div:nth-child(1) {
                font-weight: 500;
                font-size: 14px;
                color: #000000;
              }

              div:nth-child(2) {
                font-weight: 300;
                font-size: 12px;
                color: #818181;
                margin-top: 5px;
              }
            }

            .hru_right {
              width: 9px;
              height: 5px;
            }
          }

          .hru_menu {
            position: absolute;
            left: 0;
            top: 50px;
            width: 150px;
            background: #FFFFFF;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
            border-radius: 7px;
            z-index: 39;

            .rum_item {
              width: 100%;
              height: 45px;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding: 0 8px 0 13px;
              user-select: none;
              cursor: pointer;

              .umi_left {
                flex: 1;
                display: flex;
                align-items: center;

                img {
                  width: 12px;
                  height: 12px;
                }

                div {
                  font-weight: 400;
                  font-size: 12px;
                  color: #333333;
                  margin-left: 12px;
                }
              }

              .umi_right {
                width: 3px;
                height: 6px;
              }
            }
          }
        }
      }
    }

  }
}
</style>
